var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dapzap-login-btn"},[_vm._v(" NFTLIST "+_vm._s(_vm.nftList)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }